import { defineStyleConfig } from "@chakra-ui/react";

export const FormLabel = defineStyleConfig({
  baseStyle: {
    fontSize: "md",
    color: "black.800",
    fontWeight: 600,
    _dark: {
      color: "white",
    },
  },
});
